import { render, staticRenderFns } from "./navigationLinks.vue?vue&type=template&id=a220001a"
import script from "./navigationLinks.vue?vue&type=script&lang=js"
export * from "./navigationLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports